import { render, staticRenderFns } from "./tile-transactions.vue?vue&type=template&id=451f41cb&"
import script from "./tile-transactions.vue?vue&type=script&lang=js&"
export * from "./tile-transactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports